module.exports = __webpack_public_path__ + "img/image_2020-05-11_20-45-09.b7b02e18.png";